module.exports = __webpack_public_path__ + "img/binding_width.1c67da7d.png";